"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = void 0;
const typography_1 = require("../../typography");
const colors_1 = require("./colors");
const shadows_1 = require("./shadows");
exports.darkTheme = {
    colors: colors_1.colors,
    typography: typography_1.typography,
    shadows: shadows_1.shadows,
};
//# sourceMappingURL=darkTheme.js.map